// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-p_gt","advertDetailService__price":"c-p_gu"};